import * as React from 'react';
import { NavLink } from 'react-router-dom';

import { EVENTS_URL, FAQ_URL, GLOSSARY_URL, LEARN_PART_PATH_OPERATORS } from '../../shared/constants';
import { addModifiers } from '../../shared/helpers';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import analytics from '../../shared/services/analytics/analytics';

import './Learn.scss';

interface LearnSideBarProps {
  scope: 'learn' | 'simulate';
  path: string;
  navHasText: boolean;
  homeLink: boolean;
}

export const LearnSideBar = ({ scope, path, navHasText, homeLink }: LearnSideBarProps): JSX.Element => {
  const trackLearnMenu = (label: string) => {
    analytics.trackCustomEvent(scope === 'simulate' ? 'sim_click_learn_menu' : 'learn_click_sidebar_menu', { event_label: label });
  };

  return (
    <div className={addModifiers('learn__sidebar', [scope])}>
      <div className="learn__sidebar__container">
        {homeLink && <NavLink exact={true} to={`/${path}`} activeClassName="active" className="learn__submenu learn__submenu-btn--home" />}
        <NavLink
          to={`/${path}/courses`}
          activeClassName="active"
          className="learn__submenu learn__submenu-btn--video"
          onClick={() => trackLearnMenu('videos')}
        >
          {navHasText && (
            <span className="learn__submenu-link learn__submenu-link--video">
              <FormattedMessageHelper id="learnSideBar.videoCourse" />
            </span>
          )}
        </NavLink>

        <NavLink
          to={`/${path}/documentation`}
          activeClassName="active"
          className="learn__submenu learn__submenu-btn--tutorials"
          onClick={() => trackLearnMenu('documentation')}
        >
          {navHasText && (
            <span className="learn__submenu-link learn__submenu-link--tutorials">
              <FormattedMessageHelper id="learnSideBar.tutorials" />
            </span>
          )}
        </NavLink>

        <NavLink
          to={`/${path}/${LEARN_PART_PATH_OPERATORS}`}
          activeClassName="active"
          className="learn__submenu learn__submenu-btn--references"
          onClick={() => trackLearnMenu('operators')}
        >
          {navHasText && (
            <span className="learn__submenu-link learn__submenu-link--references">
              <FormattedMessageHelper id="learnSideBar.references" />
            </span>
          )}
        </NavLink>

        <a
          href={FAQ_URL}
          target="_blank"
          rel="noreferrer"
          className="learn__submenu learn__submenu-btn--faq"
          onClick={() => trackLearnMenu('faq')}
        >
          {navHasText && (
            <span className="learn__submenu-link learn__submenu-link--faq">
              <FormattedMessageHelper id="learnSideBar.faq" />
            </span>
          )}
        </a>

        <a
          href={EVENTS_URL}
          target="_blank"
          rel="noreferrer"
          className="learn__submenu learn__submenu-btn--events"
          onClick={() => trackLearnMenu('calendar')}
        >
          {navHasText && (
            <span className="learn__submenu-link learn__submenu-link--events">
              <FormattedMessageHelper id="events.events" />
            </span>
          )}
        </a>

        <a
          href={GLOSSARY_URL}
          target="_blank"
          rel="noreferrer"
          className="learn__submenu learn__submenu-btn--glossary"
          onClick={() => trackLearnMenu('glossary')}
        >
          {navHasText && (
            <span className="learn__submenu-link learn__submenu-link--glossary">
              <FormattedMessageHelper id="learnSideBar.glossary" />
            </span>
          )}
        </a>
      </div>
    </div>
  );
};
